// Account:

export type AccountTab =
    'Personal' |
    'WorkExperience' |
    'Education' |
    'Expertise' |
    'Files' |
    'Identify';

export interface AccountTabs {
    id: AccountTab;
    title: string;
};

export const accountTabs: AccountTabs[] = [
    {
        id: 'Personal',
        title: 'Personal information',
    },
    {
        id: 'WorkExperience',
        title: 'Work experience',
    },
    {
        id: 'Education',
        title: 'Education',
    },
    {
        id: 'Expertise',
        title: 'Expertise',
    },
    {
        id: 'Files',
        title: 'Uploaded files',
    },
    {
        id: 'Identify',
        title: 'Identifying',
    },
];

// -------------------------------